import { render } from "./WelcomeView.vue?vue&type=template&id=42725be0&scoped=true&ts=true"
import script from "./WelcomeView.vue?vue&type=script&lang=ts"
export * from "./WelcomeView.vue?vue&type=script&lang=ts"

import "./WelcomeView.vue?vue&type=style&index=0&id=42725be0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42725be0"]])

export default __exports__